<!--
 * @Author: Tahiti
 * @Date: 2025-11-05 19:29:46
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-04 17:21:11
 * @Description: 图片预览组件 - 不遮挡顶部菜单和侧边栏，右侧竖向展示全部图片，支持滑动切换
 * @FilePath: /weryai-web/components/Tool/SingleImgView.vue
-->
<template>
    <transition name="fade">
        <div v-if="visible" class="single-img-view-overlay w-full h-full bg-black/60 fixed top-0 left-0"
            :style="{ zIndex: overlayZIndex }" @click.self="handleClose">
            <div
                class="single-img-view-content absolute bg-black w-full xl:w-[calc(100%-88px)] max-xl:w-full xl:left-[88px] max-xl:left-0 flex flex-col lg:flex-row overflow-hidden"
                :style="{
                    ...overlayVariables,
                    '--single-img-mobile-top': `${props.mobileTopOffset}px`,
                }"
            >
                <!-- 主内容区域：图片预览 + 操作区 -->
                <div class="flex-1 flex flex-col lg:flex-row overflow-hidden">
                    <!-- 左侧：主图片预览区域 -->
                    <div class="flex-1 flex items-center justify-center p-4 lg:p-5 relative min-h-0">
                        <!-- 关闭按钮 -->
                        <button
                            class="absolute top-4 lg:top-5 bg-[#22242D] right-4 lg:right-5 z-[1001] w-[42px] h-[42px] flex items-center justify-center text-white hover:text-text-active cursor-pointer transition-all duration-200 rounded-[10px] hover:border-white/30"
                            @click="handleClose">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        <!-- <img v-if="currentImage" :src="currentImage.url" alt="Current Image"
                            class="max-w-full max-h-full min-w-[200px] min-h-[200px] object-contain cursor-pointer"
                            @click="emitOpenImagePreview(currentImage.url)" /> -->
                        <el-image v-if="currentImage" class="max-w-full max-h-full" :src="currentImage?.url" :zoom-rate="1.2" :max-scale="7"
                            :min-scale="0.2" :preview-src-list="[currentImage?.url]" :initial-index="0" fit="contain"
                            hide-on-click-modal />
                        <div v-else class="text-white text-center">
                            <p>{{ t('batchTools.noImage') }}</p>
                        </div>
                    </div>

                    <!-- 操作区：大屏幕在右侧，小屏幕在底部 -->
                    <div
                        class="flex flex-col justify-between gap-3 lg:w-[400px] lg:!mr-1 lg:mt-5 lg:mx-5 mx-4 mb-4 lg:mb-5 flex-shrink-0">
                        <div class="bg-tool-side h-full rounded-[10px] p-4 lg:p-5 overflow-y-auto">
                            <div class="flex items-center justify-between">
                                <div v-if="currentImage?.type_name"
                                    class="min-w-[88px] flex flex-col whitespace-nowrap items-start justify-center text-white text-base"
                                    type="button">
                                    <span class="max-w-[268px] truncate">
                                        {{
                                            currentImage?.request_params
                                                ?.characters?.length
                                                ? t(
                                                    'characterToImg.characterToImage'
                                                )
                                                : currentImage?.type_name
                                        }}
                                    </span>
                                    <span v-if="currentImage?.created_at" class="text-[13px] text-sub-title">{{
                                        dayjs(
                                            currentImage?.created_at
                                        ).format('YYYY/MM/DD HH:mm:ss')
                                    }}</span>
                                </div>
                                <!-- download -->
                                <button v-if="currentImage"
                                    class="min-w-[88px] disabled:cursor-not-allowed disabled:opacity-50 whitespace-nowrap flex items-center justify-center h-[41px] bg-switch-inactive-dot text-white px-5 py-[10px] rounded-[10px] border border-transparent text-sm hover:border-white/30"
                                    type="button" @click="handleDownload" :disabled="downloading">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                        fill="none" stroke="currentColor" class="w-4 h-4 mr-1">
                                        <path
                                            d="M13.3333 13.3333C13.5101 13.3333 13.6797 13.4035 13.8047 13.5285C13.9298 13.6536 14 13.8231 14 13.9999C14 14.1767 13.9298 14.3463 13.8047 14.4713C13.6797 14.5964 13.5101 14.6666 13.3333 14.6666H2.66667C2.48986 14.6666 2.32029 14.5964 2.19526 14.4713C2.07024 14.3463 2 14.1767 2 13.9999C2 13.8231 2.07024 13.6536 2.19526 13.5285C2.32029 13.4035 2.48986 13.3333 2.66667 13.3333H13.3333ZM8 1.33594C8.17681 1.33594 8.34638 1.40618 8.4714 1.5312C8.59643 1.65622 8.66667 1.82579 8.66667 2.0026V10.0553L11.86 6.86194C11.9799 6.74215 12.1408 6.6725 12.3102 6.66715C12.4796 6.6618 12.6446 6.72115 12.7718 6.83313C12.899 6.94512 12.9788 7.10133 12.9949 7.27002C13.011 7.43871 12.9623 7.60721 12.8587 7.74127L12.8027 7.80394L8.46867 12.1406C8.35396 12.2555 8.20127 12.3246 8.03925 12.3349C7.87723 12.3452 7.71701 12.296 7.58867 12.1966L7.526 12.1413L3.196 7.8186C3.07598 7.69886 3.0061 7.53788 3.00056 7.36843C2.99503 7.19898 3.05426 7.03379 3.16621 6.90646C3.27816 6.77914 3.43442 6.69925 3.60318 6.68305C3.77195 6.66685 3.94054 6.71556 4.07467 6.81927L4.13733 6.8746L7.33333 10.0639V2.0026C7.33333 1.82579 7.40357 1.65622 7.5286 1.5312C7.65362 1.40618 7.82319 1.33594 8 1.33594Z"
                                            fill="white" />
                                    </svg>
                                    {{ t('batchTools.download') }}
                                </button>
                            </div>

                            <div class="w-full h-[1px] bg-[#383A42] my-5"></div>
                            <div class="text-sm text-white font-semibold mb-3">
                                {{
                                    getOriginalImageLabel(
                                        currentImage?.request_params
                                    )
                                }}
                            </div>

                            <div class="flex flex-wrap items-center gap-2 mb-[30px]">
                                <template v-if="
                                    currentImage?.request_params?.img_urls
                                        ?.length
                                ">
                                    <div v-for="(img, index) in currentImage
                                        ?.request_params?.img_urls" :key="index"
                                        class="overflow-hidden w-[84px] aspect-square bg-black rounded-[10px]">
                                        <img :key="index"
                                            class="w-full h-full rounded-[10px] object-cover cursor-pointer hover:scale-105 transition-all duration-300"
                                            :src="img" alt="Original Image" @click="emitOpenImagePreview(img)" />
                                    </div>
                                </template>
                                <template v-else-if="
                                    currentImage?.request_params?.pic_url
                                        ?.length
                                ">
                                    <div v-for="(img, index) in currentImage
                                        ?.request_params?.pic_url" :key="index"
                                        class="overflow-hidden w-[84px] aspect-square bg-black rounded-[10px]">
                                        <img :key="index"
                                            class="w-full h-full rounded-[10px] object-cover cursor-pointer hover:scale-105 transition-all duration-300"
                                            :src="img" alt="Original Image" @click="emitOpenImagePreview(img)" />
                                    </div>
                                </template>
                                <template v-else-if="
                                    currentImage?.request_params?.image_url
                                        ?.length
                                ">
                                    <!-- 兼容 image_url 为数组（图片特效可能上传多张图） -->
                                    <template v-if="
                                        Array.isArray(
                                            currentImage?.request_params
                                                ?.image_url
                                        )
                                    ">
                                        <div v-for="(img, index) in currentImage
                                            ?.request_params?.image_url" :key="index"
                                            class="overflow-hidden w-[84px] aspect-square bg-black rounded-[10px]">
                                            <img class="w-full h-full rounded-[10px] object-cover cursor-pointer hover:scale-105 transition-all duration-300"
                                                :src="img" alt="Original Image" @click="
                                                    emitOpenImagePreview(img)
                                                    " />
                                        </div>
                                    </template>
                                    <!-- image_url 为字符串的情况 -->
                                    <div v-else class="overflow-hidden w-[84px] aspect-square bg-black rounded-[10px]">
                                        <img class="w-full h-full rounded-[10px] object-cover cursor-pointer hover:scale-105 transition-all duration-300"
                                            :src="currentImage?.request_params
                                                ?.image_url
                                                " alt="Original Image" @click="
                                                    emitOpenImagePreview(
                                                        currentImage?.request_params
                                                            ?.image_url
                                                    )
                                                    " />
                                    </div>
                                </template>
                            </div>
                            <div v-if="
                                currentImage?.request_params?.prompt ||
                                currentImage?.request_params?.change ||
                                currentImage?.prompt
                            ">
                                <div class="text-sm text-white font-semibold mb-3">
                                    {{ t('batchTools.creativeDescription') }}
                                </div>
                                <div class="text-[13px] max-h-[300px] overflow-y-auto text-white mb-[10px]">
                                    <span class="inline">
                                        <span class="break-words">{{
                                            currentImage?.request_params
                                                ?.prompt ||
                                            currentImage?.request_params
                                                ?.change ||
                                            currentImage?.prompt?.join(', ')
                                        }}</span>
                                        <span
                                            class="i-copy-icon text-sub-title inline-block hover:text-text-active w-[18px] h-[18px] cursor-pointer ml-1 align-middle"
                                            @click="
                                                handleCopyPrompts(currentImage)
                                                "></span>
                                    </span>
                                </div>
                            </div>

                            <div v-if="currentImageMetaItems.length" class="flex flex-wrap gap-1 items-center mb-[10px]">
                                <template v-for="(metaItem, index) in currentImageMetaItems" :key="`${metaItem}-${index}`">
                                    <span class="text-[13px] truncate text-white/30 block">{{
                                        metaItem
                                    }}</span>
                                    <span
                                        v-if="index < currentImageMetaItems.length - 1"
                                        class="w-[1px] h-[15px] bg-white/20"
                                    ></span>
                                </template>
                            </div>
                        </div>
                        <div v-if="
                            currentImage?.request_params &&
                            [
                                'TEXT_TO_VIDEO',
                                'IMG_TO_VIDEO',
                                'TEXT_TO_IMG',
                                'IMG_TO_IMG',
                            ].includes(currentImage?.type)
                        " class="bg-tool-side min-h-[69px] flex items-center justify-start rounded-[10px] p-4 lg:p-5">
                            <span class="flex gap-1 hover:text-text-active cursor-pointer">
                                <span class="i-refresh-icon block !w-4 !h-4 mt-[1px]">
                                </span>
                                <span class="text-[13px] h-[13px]" @click="handleRegenerate">{{
                                    t('batchTools.regenerate') }}</span>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- 右侧：竖向缩略图列表（大屏幕显示在右侧，小屏幕显示在底部） -->
                <div v-if="imageList.length > 1"
                    class="w-full lg:w-[120px] flex flex-row lg:flex-col overflow-hidden flex-shrink-0">
                    <!-- 缩略图容器 - 可滚动 -->
                    <div ref="thumbnailContainerRef"
                        class="flex-1 overflow-x-auto lg:overflow-x-hidden lg:overflow-y-auto overflow-y-hidden px-2 py-4 space-x-2 lg:space-x-0 lg:space-y-2 flex flex-row lg:flex-col scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent"
                        @wheel="handleThumbnailWheel">
                        <div v-for="(img, index) in imageList" :key="index"
                            class="w-[82px] h-[82px] aspect-square flex-shrink-0 rounded-[10px] overflow-hidden cursor-pointer border-2 transition-all duration-200 hover:border-text-active"
                            :class="{
                                'border-text-active':
                                    img.url === currentImage?.url,
                                'border-transparent':
                                    img.url !== currentImage?.url,
                            }" @click="switchImage(img)">
                            <img :src="img.url" :alt="`Thumbnail ${index + 1}`" class="w-full h-full object-cover" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup lang="ts">
/**
 * 图片预览组件
 * 全屏展示图片，背景黑色，不遮挡顶部菜单（52px header + 44px tab = 96px）和侧边栏（88px，仅大屏幕显示）
 * 右侧竖向展示全部图片缩略图，支持滑动切换
 */

import { computed, ref, watch, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { emitter } from '~/utils/emitter'
import { useI18n } from '~/composables/useI18n'
import {
    noticeMessagePopup,
    detectImageTypeFromBlob,
    getMimeTypeFromExtension,
    mimeMap,
} from '~/utils/common'
import { useCreateStore } from '~/stores/create'
import {
    getImageQualityTranslationKey,
    pickImageQualityValue,
} from '~/utils/imageQuality'
import dayjs from 'dayjs'
import { useOverlayOffset } from '~/composables/useOverlayOffset'
const createStore = useCreateStore()
const { overlayVariables } = useOverlayOffset()

const { t } = useI18n()

// Props: 接收图片URL和控制显示状态
interface Props {
    imageUrl?: string
    modelValue?: boolean // v-model 控制显示/隐藏
    /** 遮罩层 z-index，默认 49；在 chat 页创作 tab 下可传 101 以高于底部工作台 */
    overlayZIndex?: number
    /** 工具页移动端自身顶部栏高度，不属于全局 AppHeader。 */
    mobileTopOffset?: number
}

const props = withDefaults(defineProps<Props>(), {
    imageUrl: '',
    modelValue: false,
    overlayZIndex: 49,
    mobileTopOffset: 64,
})

// Emits: 发送更新事件
const emit = defineEmits<{
    'update:modelValue': [value: boolean]
}>()

// 内部显示状态
const visible = ref(props.modelValue)

// 监听外部 modelValue 变化
watch(
    () => props.modelValue,
    newVal => {
        visible.value = newVal
    }
)

// 监听内部 visible 变化，同步到外部
watch(visible, newVal => {
    emit('update:modelValue', newVal)
})

// 图片项接口
interface ImageItem {
    async?: boolean
    url: string
    type_name?: string
    prompt?: any
    model?: string
    request_params?: any
    type: string
    expect_count?: number
    img_urls?: string[]
    resolution?: string
    category?: string
    created_at?: number
}

// 当前显示的图片
const currentImage = ref<ImageItem | null>(null)

const getImageMetaItems = (item: ImageItem | null): string[] => {
    if (!item) return []

    const metaItems: string[] = []
    const aspect =
        item?.request_params?.aspect_scale || item?.request_params?.aspect_ratio
    const qualityValue = pickImageQualityValue(item?.request_params?.quality)
    const qualityTranslationKey = getImageQualityTranslationKey(qualityValue)
    const qualityLabel = qualityTranslationKey
        ? t(qualityTranslationKey)
        : qualityValue
    const resolution = item?.request_params?.resolution

    if (item.model) {
        metaItems.push(item.model)
    }
    if (aspect) {
        metaItems.push(aspect)
    }
    if (qualityLabel) {
        metaItems.push(qualityLabel)
    }
    if (resolution) {
        metaItems.push(resolution)
    }

    return metaItems
}

const currentImageMetaItems = computed(() => getImageMetaItems(currentImage.value))

// 图片列表
const imageList = ref<ImageItem[]>([])

// 缩略图容器引用
const thumbnailContainerRef = ref<HTMLElement | null>(null)

// 下载状态
const downloading = ref(false)

// 打开预览
const handleOpen = (data: any, item: any) => {
    console.log(data, item)
    visible.value = true

    // 归一化不同数据结构（支持 result_list 与 results）
    const normalize = (oneItem: any): ImageItem[] => {
        const request_params = oneItem?.request_params || {}
        const type = oneItem?.type
        const type_name = oneItem?.type_name
        const prompt =
            oneItem?.request_params?.prompt ||
            oneItem?.request_params?.change ||
            oneItem?.prompt ||
            (Array.isArray(oneItem?.prompts) ? oneItem.prompts.join(', ') : '')
        const expect_count = oneItem?.expect_count
        const category = oneItem?.category
        const created_at = oneItem?.created_at

        const list: ImageItem[] = []

        // 批量结构：result_list 为对象数组（包含 url、model）
        if (Array.isArray(oneItem?.result_list)) {
            for (const imgItem of oneItem.result_list) {
                const url = imgItem?.url || ''
                if (url) {
                    list.push({
                        url,
                        type_name,
                        prompt,
                        request_params,
                        model: imgItem?.model || '',
                        type,
                        expect_count,
                        category,
                        created_at,
                    })
                }
            }
        }

        // 非批量结构：results 可能是字符串 URL 或对象（包含 url、model）
        if (Array.isArray(oneItem?.results)) {
            for (const r of oneItem.results) {
                const url = typeof r === 'string' ? r : r?.url || ''
                if (url) {
                    list.push({
                        url,
                        type_name,
                        prompt,
                        request_params,
                        model: typeof r === 'string' ? '' : r?.model || '',
                        type,
                        expect_count,
                        category,
                        created_at,
                    })
                }
            }
        }

        return list
    }

    imageList.value = (Array.isArray(data) ? data : []).map(normalize).flat()

    // 设置当前图片（字符串 URL 或对象都兼容，找不到时兜底）
    if (typeof item === 'string') {
        currentImage.value = imageList.value.find(img => img.url === item) || {
            url: item,
            type_name: '',
            prompt: '',
            request_params: {},
            model: '',
            type: '',
            expect_count: 1,
            category: '',
            created_at: 0,
        }
    } else if (item?.url) {
        currentImage.value = imageList.value.find(
            img => img.url === item.url
        ) || {
            url: item.url,
            type_name: item.type_name || '',
            prompt: item.prompt || '',
            request_params: item.request_params || {},
            model: item.model || '',
            type: item.type || '',
            expect_count: item.expect_count || 1,
            category: item.category || '',
            created_at: item.created_at || 0,
        }
    } else {
        currentImage.value = imageList.value[0] || null
    }

    // 确保当前图片在列表中
    if (
        currentImage.value &&
        !imageList.value.find(img => img.url === currentImage.value?.url)
    ) {
        imageList.value.unshift(currentImage.value as ImageItem)
    }

    // 滚动到当前图片
    nextTick(() => {
        scrollToCurrentImage()
    })
}

// 关闭预览
const handleClose = () => {
    visible.value = false
    currentImage.value = null
    imageList.value = []
}

// 切换图片
const switchImage = (imageItem: ImageItem) => {
    currentImage.value = imageItem
    scrollToCurrentImage()
}

// 滚动到当前图片
const scrollToCurrentImage = () => {
    if (!thumbnailContainerRef.value || !currentImage.value) return

    const thumbnails = thumbnailContainerRef.value.querySelectorAll('div')
    thumbnails.forEach((thumb, index) => {
        if (imageList.value[index]?.url === currentImage.value?.url) {
            thumb.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            })
        }
    })
}

// 缩略图区域滚轮事件处理
const handleThumbnailWheel = (e: WheelEvent) => {
    // 阻止事件冒泡，避免影响主图区域
    e.stopPropagation()
}

// 键盘事件处理
const handleKeydown = (e: KeyboardEvent) => {
    if (!visible.value) return

    switch (e.key) {
        case 'Escape':
            handleClose()
            break
        case 'ArrowLeft':
            e.preventDefault()
            switchToPrevious()
            break
        case 'ArrowRight':
            e.preventDefault()
            switchToNext()
            break
    }
}

// 切换到上一张
const switchToPrevious = () => {
    if (imageList.value.length <= 1 || !currentImage.value) return

    const currentIndex = imageList.value.findIndex(
        img => img.url === currentImage.value?.url
    )
    if (currentIndex > 0) {
        const prevImage = imageList.value[currentIndex - 1]
        if (prevImage) {
            switchImage(prevImage)
        }
    } else {
        // 循环到最后一张
        const lastImage = imageList.value[imageList.value.length - 1]
        if (lastImage) {
            switchImage(lastImage)
        }
    }
}

// 切换到下一张
const switchToNext = () => {
    if (imageList.value.length <= 1 || !currentImage.value) return

    const currentIndex = imageList.value.findIndex(
        img => img.url === currentImage.value?.url
    )
    if (currentIndex < imageList.value.length - 1) {
        const nextImage = imageList.value[currentIndex + 1]
        if (nextImage) {
            switchImage(nextImage)
        }
    } else {
        // 循环到第一张
        const firstImage = imageList.value[0]
        if (firstImage) {
            switchImage(firstImage)
        }
    }
}

// 下载图片
const handleDownload = async () => {
    if (!currentImage.value || downloading.value) return

    try {
        downloading.value = true
        // 显示开始下载的提示
        noticeMessagePopup(
            t('batchTools.downloading') || 'Downloading image...',
            t('common.tip'),
            'info',
            2000
        )
        const imageUrl = currentImage.value.url

        // 对于跨域资源，尝试使用 fetch 下载
        try {
            const response = await fetch(imageUrl)
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            // 获取正确的 MIME 类型
            let contentType = response.headers.get('content-type') || ''

            // 获取 blob 数据
            const blob = await response.blob()

            // 通过文件头检测图片类型（最准确的方法）
            const detectedType = await detectImageTypeFromBlob(blob)

            // 确定文件扩展名和 MIME 类型
            let fileExtension = 'png'
            let mimeType = contentType

            // 优先使用文件头检测的结果
            if (detectedType !== 'unknown') {
                fileExtension = detectedType
                mimeType = getMimeTypeFromExtension(detectedType)
            } else if (mimeType) {
                // 如果文件头检测失败，根据 MIME 类型确定扩展名

                const baseMimeType =
                    mimeType.split(';')[0]?.trim().toLowerCase() || ''
                fileExtension = mimeMap[baseMimeType] || 'png'
                mimeType = getMimeTypeFromExtension(fileExtension)
            } else {
                // 如果都没有，默认使用 png
                fileExtension = 'png'
                mimeType = 'image/png'
            }

            // 确保扩展名是小写（macOS 对大小写敏感）
            fileExtension = fileExtension.toLowerCase()

            // 确保 MIME 类型正确（移除参数，确保格式正确）
            if (mimeType) {
                mimeType =
                    mimeType.split(';')[0]?.trim().toLowerCase() || mimeType
            }
            if (!mimeType || !mimeType.startsWith('image/')) {
                mimeType = getMimeTypeFromExtension(fileExtension)
            }

            // 生成文件名：'weryai_' + 时间戳
            const timestamp = Date.now()
            const finalFileName = `weryai_${timestamp}.${fileExtension}`

            // 创建正确 MIME 类型的 blob（确保类型匹配，这对 macOS 缩略图很重要）
            const typedBlob = new Blob([blob], { type: mimeType })

            // 创建一个临时的 a 标签来触发下载
            const link = document.createElement('a')
            link.download = finalFileName
            link.href = window.URL.createObjectURL(typedBlob)
            link.style.display = 'none'
            // 设置 download 属性，确保浏览器使用指定的文件名
            link.setAttribute('download', finalFileName)

            document.body.appendChild(link)
            link.click()

            // 等待一小段时间确保下载开始（macOS 可能需要更多时间）
            await new Promise(resolve => setTimeout(resolve, 200))

            document.body.removeChild(link)

            // 清理 blob URL（延迟清理，确保下载完成）
            setTimeout(() => window.URL.revokeObjectURL(link.href), 1000)

            noticeMessagePopup(
                t('batchTools.downloadSuccess') || 'Download successful',
                t('common.tip'),
                'success',
                3000
            )
        } catch (error) {
            noticeMessagePopup(
                t('batchTools.downloadFailed') || 'Download failed',
                t('common.tip'),
                'error',
                3000
            )
            // 如果 fetch 失败（可能是跨域问题），直接打开链接
            console.warn('Fetch下载失败，尝试直接下载:', error)
            const link = document.createElement('a')
            link.href = imageUrl
            link.download = `weryai_${Date.now()}.png`
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    } catch (error) {
        console.error('下载失败:', error)
        noticeMessagePopup(
            t('batchTools.downloadFailed') || 'Download failed',
            t('common.tip'),
            'error',
            3000
        )
    } finally {
        downloading.value = false
    }
}

// @ts-ignore
const is_client = import.meta.client
// 复制提示词
const handleCopyPrompts = (item: any) => {
    if (
        (!item.request_params?.prompt &&
            !item.request_params?.change &&
            !item.prompts) ||
        !is_client
    )
        return
    const prompt =
        item.request_params?.prompt ||
        item.request_params?.change ||
        item.prompts.join(', ')
    navigator.clipboard.writeText(prompt)
    noticeMessagePopup(t('batchTools.copySuccess'), '', 'success', 3000)
}

const generate_loading = ref(false)

const handleRegenerate = async () => {
    const { request_params, model, expect_count } =
        currentImage.value as ImageItem
    if (!request_params) return
    const {
        aspect_scale,
        image_number,
        prompt,
        public_visible,
        copyright_protection,
        change,
        img_urls,
        aspect_ratio,
        single_img_edit,
        use_web_search,
        resolution,
        img_num,
    } = request_params

    const data_: any = {
        async: true,
        aspect_scale: aspect_scale || aspect_ratio,
        aspect_ratio: aspect_scale || aspect_ratio,
        image_number: image_number || img_num || expect_count,
        model: request_params?.model || model,
        prompt: prompt || change,
        source_type: 'NEW_WERYA',
        public_visible,
        copyright_protection,
        create_type: img_urls?.length ? 'IMG_EDIT_BATCH' : 'TEXT_TO_IMG_BATCH',
        type: 'image',
    }
    if (data_.create_type === 'IMG_EDIT_BATCH') {
        data_.img_urls = img_urls
    }
    if (single_img_edit) {
        data_.single_img_edit = single_img_edit
    }
    if (use_web_search) {
        data_.use_web_search = use_web_search
    }
    if (resolution) {
        data_.resolution = resolution
    }
    // 把GEMINI_3_PRO_IMAGE_PREVIEW 替换为 CHATBOT_GEMINI_3_PRO_IMAGE
    data_.model = data_.model?.replace(
        'GEMINI_3_PRO_IMAGE_PREVIEW',
        'CHATBOT_GEMINI_3_PRO_IMAGE_PREVIEW'
    )
    if (generate_loading.value) return
    generate_loading.value = true

    try {
        // 只创建任务，不进行任务状态轮询
        // 轮询通过历史记录轮询来处理
        await createStore.handleCreateImageOrVideo(data_)
    } catch (error: any) {
        noticeMessagePopup(error?.message || 'Creating Failed')
    } finally {
        generate_loading.value = false
        handleClose()
    }
}

const emitOpenImagePreview = (img: string) => {
    emitter.emit('open-image-preview', img)
}

const getOriginalImageLabel = (params: any) => {
    const {
        image_with_button_img,
        end_pic_url,
        pic_url,
        img_urls,
        image_url,
        characters,
    } = params || {}
    if (image_with_button_img) {
        return t('batchTools.singleImgReference')
    } else if (end_pic_url) {
        return t('batchTools.firstAndEndFrame')
    } else if (characters?.length > 1) {
        return t('characterToImg.origin_img')
    } else if (pic_url?.length > 1 || img_urls?.length > 1) {
        return t('batchTools.multiImgReference')
    } else if (Array.isArray(image_url) && image_url.length > 1) {
        // 兼容图片特效的多图情况
        return t('batchTools.multiImgReference')
    }
    return t('batchTools.singleImgReference')
}
onMounted(() => {
    emitter.on(
        'open-single-img-preview',
        ({ data, item }: { data: any; item: any }) => handleOpen(data, item)
    )
    emitter.on('close-single-img-preview', handleClose)
    window.addEventListener('keydown', handleKeydown)
})

onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeydown)
    emitter.off(
        'open-single-img-preview',
        ({ data, item }: { data: any; item: any }) => handleOpen(data, item)
    )
    emitter.off('close-single-img-preview', handleClose)
})
</script>

<style scoped lang="less">
/* 内容区在遮罩内保持层级，关闭按钮已有 z-[1001] */
.single-img-view-content {
    z-index: 1;
    top: var(--single-img-mobile-top, 64px);
    height: calc(100dvh - var(--single-img-mobile-top, 64px));

    @media (min-width: 1024px) {
        top: var(--app-overlay-top, var(--app-header-bottom, 75px));
        height: var(--app-overlay-height, var(--app-content-height, calc(100dvh - 75px)));
    }
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* 自定义滚动条样式 */
.scrollbar-thin::-webkit-scrollbar {
    width: 6px;
}

.scrollbar-thin::-webkit-scrollbar-track {
    background: transparent;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
    background-color: rgba(107, 114, 128, 0.5);
    border-radius: 3px;
}

.scrollbar-thin::-webkit-scrollbar-thumb:hover {
    background-color: rgba(107, 114, 128, 0.7);
}

/* 缩略图选中效果 */
.thumbnail-item {
    transition: all 0.2s ease;
}

.thumbnail-item:hover {
    transform: scale(1.05);
}

:deep(.el-image-viewer__close) {
    background: #22242D;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s;

    &:hover {
        border: 1px solid rgba(255, 255, 255, 0.3);
        color: var(--weryai-text-active);

    }

}

:deep(.el-image-viewer__actions) {
    background: #22242D;

}

:deep(.el-image__inner) {
    /* max-width: 400px; */
    max-height: 70vh;
}
</style>
